<mat-menu #helpMenu="matMenu" class="rkt-menu header-dropdown help-menu">
  <app-help-contacts></app-help-contacts>
</mat-menu>
